import type * as React from 'react';
import { get } from '@Domain/Api';
import accountWorkflowsFetched, {
	type AccountWorkflowsFetchedAction,
	type AccountWorkflowsFetchedPayload,
} from '@Application/SubjectTypeDefinitions/Actions/accountWorkflowsFetched';
import accountWorkflowsFetchFailed, {
	type AccountWorkflowsFetchFailedAction,
} from '@Application/SubjectTypeDefinitions/Actions/accountWorkflowsFetchFailed';
import type FetchAccountWorkflows from '@Application/SubjectTypeDefinitions/Queries/FetchAccountWorkflows';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = AccountWorkflowsFetchedAction | AccountWorkflowsFetchFailedAction;

export default (query: FetchAccountWorkflows) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<AccountWorkflowsFetchedPayload>(
				`${parameters.api.host}/api/accounts/${query.accountId}/workflows`,
			);

			const action = accountWorkflowsFetched(payload, query.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = accountWorkflowsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
